@if (countrySelectorService.displayIsoCodes$ | async; as isoCode) {
  <a class="KbCountryFlag" (click)="getCountrySelectorPageRoute($event)" href="/countrySelectorPage"
    [ngClass]="isLoggedIn?'sm':''">
    @if (countrySelectorService.mediaUrl$ | async; as mediaUrl) {
      <img [src]="baseUrl + mediaUrl"
        [alt]="isoCode[0]" />
    }
  </a>
}